import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles/index';
import { Select, MenuItem, InputLabel } from 'material-ui';
import { connect } from 'react-redux';
const styles = theme => ({
    error: {
        padding: '1px',
        'border-bottom': '.1rem solid red',
    },
    normal: {
        padding: '1px',
        'border-bottom': '1px solid grey',
    }
});
class SelectSimple extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.currentIndex
        };

    }
    onChange = (event) => {
        this.setState({ value: event.target.value });
        if (this.props.onChange) {
            this.props.onChange(event.target.value);
        }
    };

    render() {
        const { classes, id } = this.props;
        let { options, error, selection, labelProp, codeProp, label, promptText } = this.props;

        if (!promptText) {
            promptText = 'Select...';
        }
        if (!labelProp) {
            labelProp = 'label';
        }
        if (!codeProp) {
            codeProp = 'code';
        }
        if (!options) {
            options = [];
        }
        return (
            <div className={'SelectNative ' + (error ? classes.error : classes.normal)}>
                {label ?
                    <InputLabel data-shrink="true">{label}</InputLabel> : ''
                }
                <Select id={id} style={{ width: '100%', border: 'none' }} onChange={this.onChange} value={selection || this.state.value}>
                    <MenuItem className="select-simple-item" value="sn-none" value="" disabled hidden>{promptText}</MenuItem>
                    {options.map(o => {
                        return <MenuItem className="select-simple-item" value={'sn-' + o[codeProp]} value={o[codeProp]}>{o[labelProp]}</MenuItem>;
                    })}
                </Select>
            </div>
        );
    }
}
SelectSimple.propTypes = {
    options: PropTypes.array.isRequired,
    labelProp: PropTypes.string,
    promptText: PropTypes.string,
    codeProp: PropTypes.string,
    onChange: PropTypes.func
};

const mapStateToProps = state => ({
    currentIndex: state.selectSuggestionRedux.currentIndex,
});

export default connect(mapStateToProps)((withStyles(styles))(SelectSimple));


// WEBPACK FOOTER //
// ./src/ui/SelectSimple.js